/**
 * Constants for table-related operations
 */

// Supabase error codes
export const SUPABASE_ERROR_CODES = {
  NO_ROWS_FOUND: 'PGRST116', // No rows returned
  UNIQUE_VIOLATION: '23505',
  FOREIGN_KEY_VIOLATION: '23503',
  NOT_NULL_VIOLATION: '23502',
} as const;

// Error message patterns
export const ERROR_PATTERNS = {
  UNIQUE_CONSTRAINT: /unique constraint|already exists/i,
  PERMISSION_DENIED: /permission|forbidden|denied|unauthorized/i,
  NETWORK_ERROR: /network|fetch|ERR_NETWORK|ERR_INTERNET_DISCONNECTED/i,
} as const;

// User-friendly error messages
export const ERROR_MESSAGES = {
  TABLE_ALREADY_EXISTS: 'A table already exists for this topic. Please refresh the page to see it.',
  PERMISSION_DENIED: 'You do not have permission to create a table in this topic.',
  NETWORK_ERROR: 'Network error: Unable to create table. Please check your connection and try again.',
  OFFLINE_TABLE_CREATION: 'Cannot create tables while offline. Please connect to the internet and try again.',
  GENERIC_CREATE_ERROR: 'Failed to create table',
} as const;

// Table defaults
export const TABLE_DEFAULTS = {
  DEFAULT_TABLE_NAME: 'New Table',
  DEFAULT_COLUMN_COUNT: 2,
  DEFAULT_ROW_COUNT: 10,
  DEFAULT_CELL_VALUE: '',
} as const;

// Type guards
export function isTableDefinitionData(data: unknown): data is import('./tableTypes').TableDefinitionData {
  return (
    typeof data === 'object' &&
    data !== null &&
    'id' in data &&
    'topic_id' in data &&
    'name' in data &&
    typeof (data as any).id === 'string' &&
    typeof (data as any).topic_id === 'string' &&
    typeof (data as any).name === 'string'
  );
}

export function isSupabaseError(error: unknown): error is { code: string; message: string; details?: string } {
  return (
    typeof error === 'object' &&
    error !== null &&
    'code' in error &&
    typeof (error as any).code === 'string'
  );
}